<script>
    import _ from 'lodash'
    import ListUtils from '@/utils/list'
    import OrgService from '@/request/user/org'
    import PatientService from '@/request/patient/patient'
    import PositionService from '@/request/dictionary/position'
    // import OrgUserService from '@/request/user/orguser'
    import DiagnosisService from '@/request/dictionary/diagnosis'
    import RecordService from '@/request/record/record'
    import DoctorService from '@/request/record/doctor'
    export default {
        data () {
            let idCardValidity = (rule, code, callback) => {
                var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
                var tip = ""
                var pass = true
                if (!code ) {
                    callback()
                } else if (!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
                    tip = "身份证号格式错误"
                    pass = false;
                } else if (!city[code.substr(0, 2)]) {
                    tip = "地址编码错误"
                    pass = false
                } else {
                    // 18位身份证需要验证最后一位校验位
                    if (code.length === 18) {
                        code = code.split('')
                        if (code[code.length -1] === 'x') {
                            code[code.length -1] = 'X'
                        }
                        // ∑(ai×Wi)(mod 11)
                        // 加权因子
                        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
                        // 校验位
                        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
                        var sum = 0
                        var ai = 0
                        var wi = 0
                        for (var i = 0; i < 17; i++) {
                            ai = code[i]
                            wi = factor[i]
                            sum += ai * wi
                        }
                        var last = parity[sum % 11];
                        if (last != code[17]) {
                            tip = "校验位错误"
                            pass = false
                        }
                    }
                }
                if (!pass) {
                    callback(new Error(tip))
                } else {
                    callback()
                }
            }
            return {
                patient: {
                    id: null,
                    historySn: null,
                    name: null,
                    sex: 1,
                    age: null,
                    mobile: null,
                    identity: null,
                    birthday: null,
                    provinceSn: null,
                    province: null,
                    citySn: null,
                    city: null,
                    countySn: null,
                    county: null,
                    townsSn: null,
                    towns: null,
                    villageSn: null,
                    village: null,
                    house: null,
                    positions: []
                },
                record: {
                    id: null,
                    historySn: null,
                    pat: null,
                    hospitalized: 1,
                    bedid: null,
                    oid: null,
                    attending: null,
                    discoverDate: null,
                    visitsDate: null,
                    admissionDate: null,
                    diagnose: null,
                    stateOfAnIllness: null,
                    oidPath: []
                },
                patientRules: {
                    name: [{ required: true, message: '患者姓名不能为空' }],
                    age: [{ type: 'number', max: 200, required: false, message: '年龄输入不正确'}],
                    identity: [{validator: idCardValidity, required: false}]
                },
                recordRules: {
                    oid: [{required: true, message: '科室不能为空'}],
                    historySn: [{ required: true, message: '病历号不能为空' }],
                    bedid: [{required: true, message: '床号不能为空' }]
                },
                hospital: null,
                diagnoses: [],
                orgSelection: [],
                singleOrg: true,
                positionSelection: [],
                diagnoseLoading: false,
                diagnoseSelection: [],
                doctorSelection: [],
                saving: false
            }
        },

        created: function () {
            let paramsHospitalized = this.$route.params.hospitalized
            if (paramsHospitalized) {
                this.record.hospitalized = paramsHospitalized
            } else if (paramsHospitalized !== 0) {
                this.record.hospitalized = 1
            } else {
                this.record.hospitalized = 0
            }
            this.listOrg()
            this.listPosition()
        },
        watch: {
            'record.oidPath': function (val) {
                if (val && val.length > 0) {
                    this.record.oid = _.findLast(val)
                    this.hospital = null
                    let orgPath = ListUtils.findFromTree(this.orgSelection, this.record.oid)
                    if (orgPath.length > 0) {
                        for (let i = 0; i < orgPath.length; i++) {
                            if (orgPath[i].otsn === 'lx0001001') {
                                this.hospital = orgPath[i]
                                break
                            }
                        }
                    }
                } else {
                    this.record.oid = null
                }
            },
            'record.oid': function () {
                this.listDoctor()
            },
            'patient.positions': function (val) {
                if (!val || val.length <= 0) {
                    return
                }
                let self = this
                self.listPosition(null, null, val, 0)
            },
            'patient.id': function (val) {
                this.record.pat = val
            },
            'patient.identity': function (val) {
                if (val) {
                    this.patient.age = '';
                }
            },
            'record.historySn': function (nval, oval) {
                if (this.patient.historySn && this.patient.id && oval === this.patient.historySn) {
                    this.patient = {
                        id: null,
                        historySn: null,
                        name: null,
                        sex: 1,
                        age: null,
                        mobile: null,
                        identity: null,
                        birthday: null,
                        provinceSn: null,
                        citySn: null,
                        countySn: null,
                        townsSn: null,
                        villageSn: null,
                        house: null,
                        positions: []
                    }
                }
            }
        },
        methods: {
            listOrg () {
                let self = this
                OrgService.listOrg({
                    typeSns: 'lx0001,lx0001001,lx0001001001',
                    descendant: 1,
                    parents: 1
                }).then(res => {
                    let orgs = res.result ? res.result : []
                    self.orgSelection = _.clone(ListUtils.listToTree(orgs))
                    if (_.isEmpty(orgs)) {
                        self.singleOrg = true
                        return
                    }
                    let count = 0
                    _.forEach(orgs, org => {
                        if (org.otsn === 'lx0001001001') {
                            count += 1
                        }
                    })
                    if (count > 1) {
                        self.singleOrg = false
                    }
                    let path = []
                    let item = self.orgSelection[0]
                    while (item) {
                        path.push(item.id)
                        if (!item.children || item.children.length <= 0) {
                            break
                        }
                        item = item.children[0]
                    }
                    self.$set(self.record, 'oidPath', _.cloneDeep(path))
                })
            },
            listDoctor () {
                if (!this.record.oid) {
                    this.doctorSelection = []
                    return
                }
                let self = this
                /*OrgUserService.list({
                  oids: self.record.oid
                }).then(res => {
                  let data = res.result ? res.result : []
                  let ds = []
                  _.forEach(data, doctor => {
                    if (_.findIndex(ds, {'uid': doctor.uid}) >= 0) {
                      return
                    }
                    ds.push(doctor)
                  })
                  self.doctorSelection = _.clone(ds)
                })*/
                DoctorService.list({
                    oids: self.record.oid
                }).then(res => {
                    let data = res.result ? res.result : []
                    self.doctorSelection = _.clone(data)
                })
            },
            listDiagnosis (query) {
                let self = this
                self.diagnoseLoading = true
                DiagnosisService.find({
                    pageOffset: 1,
                    pageSize: 100
                }, {
                    match: query || null
                }).then(res => {
                    let data = res.result['content'] || []
                    if (query) {
                        let evens = _.remove(data, item => {
                            return item.name === query
                        })
                        if (!_.isEmpty(evens)) {
                            data = _.concat(evens, data)
                        }
                    }
                    data = _.uniqBy(data, 'name')
                    self.diagnoseSelection = _.cloneDeep(data)
                    self.diagnoseLoading = false
                }, () => {
                    self.diagnoseSelection = []
                    self.diagnoseLoading = false
                })
            },
            listPosition: function (parent, best, sns, index) {
                if (!best) {
                    best = 4
                }
                if (!index) {
                    index = 0
                }
                if (parent && parent.leaf) {
                    return
                }
                let self = this
                let sn = (sns && sns.length > index) ? sns[index] : null
                if (sn && parent && parent.children && parent.children.length > 0) {
                    let chi = _.findIndex(parent.children, {'sn': sn})
                    if (chi >= 0) {
                        self.listPosition(parent.children[chi], best, sns, ++index)
                    }
                    return
                }
                if (!parent && sns && sns.length > 0 && self.positionSelection.length > 0) {
                    index = 0
                    let chi = _.findIndex(self.positionSelection, {'sn': sns[index]})
                    if (chi >= 0) {
                        self.listPosition(self.positionSelection[chi], best, sns, ++index)
                    }
                    return
                }
                let level = parent ? (parent.level + 1) : 1
                PositionService.list({
                    psn: parent ? parent.sn : null
                }).then((data) => {
                    data = data.result
                    if (data && data.length > 0) {
                        let children = []
                        for (let i = 0; i < data.length; i++) {
                            let item = _.cloneDeep(data[i])
                            item.parent = parent
                            item.index = i
                            if (level >= best) {
                                item.leaf = true
                            } else {
                                item.leaf = false
                                item.children = []
                            }
                            children.push(item)
                        }
                        if (parent) {
                            children = parent.children = _.clone(children)
                        } else {
                            children = self.positionSelection = _.clone(children)
                        }
                        if (sn) {
                            let chi = _.findIndex(children, {'sn': sns[index]})
                            if (chi >= 0) {
                                self.listPosition(children[chi], best, sns, ++index)
                            }
                        }
                    } else {
                        if (parent) {
                            parent.leaf = true
                            delete parent.children
                        }
                    }
                }, () => {
                    if (parent) {
                        parent.leaf = true
                        delete parent.children
                    }
                })
            },
            loadPatient () {
                let self = this
                PatientService.load({
                    id: this.patient.id,
                    identity: this.patient.identity,
                    historySn: this.record.historySn,
                    hid: this.hospital.id
                }).then(res => {
                    let data = res.result ? res.result : null
                    self.patient = data ? _.cloneDeep(data) : {
                        id: null,
                        historySn: null,
                        name: null,
                        sex: 1,
                        age: null,
                        mobile: null,
                        identity: null,
                        birthday: null,
                        provinceSn: null,
                        citySn: null,
                        countySn: null,
                        townsSn: null,
                        villageSn: null,
                        house: null,
                        positions: []
                    }
                    if (self.patient.id) {
                        self.patient.historySn = self.record.historySn
                    }
                    this.setPatientPositions()
                })
            },
            setPatientPositions () {
                let ps = []
                if (this.patient.provinceSn) {
                    ps.push(this.patient.provinceSn)
                }
                if (this.patient.citySn && ps.length === 1) {
                    ps.push(this.patient.citySn)
                }
                if (this.patient.countySn && ps.length === 2) {
                    ps.push(this.patient.countySn)
                }
                if (this.patient.townsSn && ps.length === 3) {
                    ps.push(this.patient.townsSn)
                }
                if (this.patient.villageSn && ps.length === 4) {
                    ps.push(this.patient.villageSn)
                }
                this.$set(this.patient, 'positions', _.clone(ps))
            },
            handleHistorySnBlur () {
                let self = this
                PatientService.load({
                    historySn: self.record.historySn,
                    hid: self.hospital.id
                }).then(res => {
                    let data = res.result ? res.result : null
                    if (data) {
                        if (self.patient.id && self.patient.id !== data.id) {
                            self.$confirm('病历号：' + self.record.historySn + '已经被其它患者占用！更改病历号还是使用病历号关联的患者？', '提示', {
                                confirmButtonText: '更改患者',
                                cancelButtonText: '更改病历号',
                                type: 'warning'
                            }).then(() => {
                                self.patient = _.cloneDeep(data)
                                self.patient.historySn = self.record.historySn
                                this.setPatientPositions()
                            }).catch(() => {
                                self.record.historySn = null
                            })
                        }
                    }
                })
            },
            querySearchPatient (queryString, cb) {
                let self = this
                let result = []
                if (queryString) {
                    PatientService.load({
                        id: self.patient.id,
                        identity: self.patient.identity,
                        historySn: self.record.historySn,
                        hid: self.hospital.id
                    }).then(res => {
                        let data = res.result ? res.result : null
                        if (data) {
                            data.historySn = self.record.historySn
                            result.push(data)
                            self.patient = _.cloneDeep(data)
                        }
                        cb(result)
                    })
                } else {
                    cb(result)
                }
            },
            querySearchPatientByIdentity (queryString, cb) {
                let self = this
                let result = []
                if (queryString) {
                    PatientService.load({
                        id: self.patient.id,
                        identity: self.patient.identity,
                        historySn: self.record.historySn,
                        hid: self.hospital.id
                    }).then(res => {
                        let data = res.result ? res.result : null
                        if (data) {
                            data.historySn = self.record.historySn
                            result.push(data)
                            // self.patient = _.cloneDeep(data)
                        }
                        cb(result)
                    })
                } else {
                    cb(result)
                }
            },
            handleSelectPatient (item) {
                if (item) {
                    if (item.historySn) {
                        this.record.historySn = item.historySn
                    }
                    this.patient = _.cloneDeep(item)
                    this.setPatientPositions()
                }
            },
            clearPatient () {
                this.patient = {}
                this.record.historySn = null
            },
            changePatientPostion () {
                let self = this
                return new Promise((resolve) => {
                    if (_.isEmpty(self.patient.positions)) {
                        self.patient.provinceSn = null
                        self.patient.province = null
                        self.patient.citySn = null
                        self.patient.city = null
                        self.patient.countySn = null
                        self.patient.county = null
                        self.patient.townsSn = null
                        self.patient.towns = null
                        self.patient.villageSn = null
                        self.patient.village = null
                        resolve()
                        return
                    }
                    PositionService.path({
                        sn: _.last(self.patient.positions)
                    }).then(res => {
                        let data = res.result
                        if (!_.isEmpty(data)) {
                            self.patient.provinceSn = data[0] ? data[0].sn : null
                            self.patient.province = data[0] ? data[0].name : null
                            self.patient.citySn = data[1] ? data[1].sn : null
                            self.patient.city = data[1] ? data[1].name : null
                            self.patient.countySn = data[2] ? data[2].sn : null
                            self.patient.county = data[2] ? data[2].name : null
                            self.patient.townsSn = data[3] ? data[3].sn : null
                            self.patient.towns = data[3] ? data[3].name : null
                            self.patient.villageSn = data[4] ? data[4].sn : null
                            self.patient.village = data[4] ? data[4].name : null
                        } else {
                            self.patient.provinceSn = null
                            self.patient.province = null
                            self.patient.citySn = null
                            self.patient.city = null
                            self.patient.countySn = null
                            self.patient.county = null
                            self.patient.townsSn = null
                            self.patient.towns = null
                            self.patient.villageSn = null
                            self.patient.village = null
                        }
                    }).finally(() => {
                        resolve()
                    })
                })
            },
            checkBedid () {
                let self = this
                return new Promise((resolve, reject) => {
                    if (_.isEmpty(self.hospital)) {
                        resolve()
                        return
                    }
                    if (!self.record.bedid) {
                        resolve()
                        return
                    }
                    RecordService.count({
                        hospitalized: 1,
                        status: '1,2,3,4,5',
                        hids: self.hospital.id,
                        bedid: self.record.bedid
                    }).then(res => {
                        let data = res.result
                        if (data) {
                            self.$confirm('床位号：' + self.record.bedid + '已经被其它患者占用！如果继续保存，原病历将自动出院！', '提示', {
                                confirmButtonText: '强制出院',
                                cancelButtonText: '更改床号',
                                type: 'warning'
                            }).then(() => {
                                self.$message({
                                    message: '保存后，原[' + self.record.bedid + ']床的病历出院',
                                    type: 'warning'
                                })
                                resolve()
                            }).catch(() => {
                                self.record.bedid = null
                                reject(new Error('输入新床号'))
                            })
                        } else {
                            resolve()
                        }
                    }).catch(() => {
                        resolve()
                    })
                })
            },
            splitDiagnose (names) {
                var patt = new RegExp('([A-Za-z\\u4e00-\\u9fa5]|\\d(?=\\u578b)){1,}?([（\\(][^\\)）\\t\\n\\r\\f]{1,}[\\)）]|([A-Za-z0-9]{1,}[,;，；、/]{1}(?=[A-Za-z0-9])|[A-Za-z0-9]{1,}[_―/\\-]{1}[A-Za-z0-9]{1,}){1,}|[A-Za-z]{0,}[0-9]{1,}(?=[\\u4e00-\\u9fa5])|[A-Za-z°\\u4e00-\\u9fa5\\u2150-\\u218F]){0,}[\\u4e00-\\u9fa5A-Za-z]{0,}', 'g')
                let result = []
                var item = null
                names = [].concat(names)
                _.forEach(names, name => {
                    if (_.isNumber(name)) {
                        result.push(name)
                        return
                    }
                    while ((item = patt.exec(name)) != null) {
                        result.push(item[0])
                    }
                })
                return result
            },
            saveDiagnoses () {
                let self = this
                let promises = []
                let diagnosesIds = []
                if (!_.isEmpty(self.diagnoses)) {
                    let tempDiagnose = self.splitDiagnose(self.diagnoses)
                    _.forEach(tempDiagnose, value => {
                        if (_.isNumber(value)) {
                            diagnosesIds.push(value)
                        } else {
                            promises.push(DiagnosisService.save({
                                hid: self.hospital.id,
                                name: value
                            }))
                        }
                    })
                }
                let message = this.$message({
                    message: '正在保存诊断信息...',
                    center: true,
                    duration: 0
                })
                return new Promise((resolve, reject) => {
                    if (_.isEmpty(self.diagnoses)) {
                        self.record.diagnose = null
                        message.close()
                        resolve()
                        return
                    }
                    if (_.isEmpty(promises)) {
                        self.record.diagnose = _.join(diagnosesIds)
                        message.close()
                        resolve()
                        return
                    }
                    Promise.all(promises).then(values => {
                        if (_.isEmpty(values)) {
                            self.record.diagnose = _.join(diagnosesIds)
                            message.close()
                            resolve()
                            return
                        }
                        _.forEach(values, value => {
                            let data = value.result
                            if (!data) {
                                return
                            }
                            if (_.indexOf(diagnosesIds, data.id) < 0) {
                                diagnosesIds.push(data.id)
                            }
                        })
                        self.record.diagnose = _.join(diagnosesIds)
                        message.close()
                        resolve()
                    }, err => {
                        message.close()
                        reject(err)
                    })
                })
            },
            savePatient () {
                let self = this
                let message = this.$message({
                    message: '正在保存患者信息...',
                    center: true,
                    duration: 0
                })
                return new Promise((resolve, reject) => {
                    if (self.patient.id) {
                        message.close()
                        resolve()
                        return
                    }
                    self.$refs['patientForm'].validate(valid => {
                        if (valid) {
                            self.changePatientPostion().finally(() => {
                                PatientService.save(self.patient).then(res => {
                                    let data = res.result || null
                                    if (!data) {
                                        message.close()
                                        reject(new Error('保存患者信息失败'))
                                        return
                                    }
                                    _.assign(self.patient, data)
                                    message.close()
                                    resolve()
                                }, err => {
                                    message.close()
                                    reject(err)
                                })
                            })
                        } else {
                            message.close()
                            reject(new Error('表单验证失败!'))
                        }
                    })
                })
            },
            saveRecord () {
                let self = this
                let message = this.$message({
                    message: '正在保存病历信息...',
                    center: true,
                    duration: 0
                })
                return new Promise((resolve, reject) => {
                    if (!self.record.pat) {
                        if (self.patient.id) {
                            self.record.pat = self.patient.id
                        } else {
                            message.close()
                            reject(new Error('保存病历信息失败'))
                            return
                        }
                    }
                    self.$refs['baseForm'].validate(valid1 => {
                        if (valid1) {
                            self.$refs['recordForm'].validate(valid => {
                                if (valid) {
                                    self.checkBedid().then(() => {
                                        let _record = _.cloneDeep(self.record)
                                        delete _record.oidPath
                                        RecordService.save(_record).then(res => {
                                            let data = res.result || null
                                            if (!data) {
                                                message.close()
                                                reject(new Error('保存病历信息失败'))
                                                return
                                            }
                                            _.assign(self.record, data)
                                            message.close()
                                            resolve(data)
                                        }).catch(err => {
                                            message.close()
                                            reject(err)
                                        })
                                    }).catch(error => {
                                        message.close()
                                        reject(error)
                                    })
                                } else {
                                    message.close()
                                    reject(new Error('表单验证失败!'))
                                }
                            })
                        } else {
                            message.close()
                            reject(new Error('表单验证失败!'))
                        }
                    })
                })
            },
            saveAll () {
                let self = this
                self.saving = true
                self.saveDiagnoses().then(() => {
                    self.savePatient().then(() => {
                        self.saveRecord().then(record => {
                            self.$message({
                                message: '成功创建病历',
                                type: 'success'
                            })
                            self.$router.push({name: 'record_show', params: {id: record.id}})
                        }).catch(error => {
                            self.$message.error(error && error.message ? error.message : '保存病历信息失败')
                        }).finally(() => {
                            self.saving = false
                        })
                    }).catch(error => {
                        self.$message.error(error)
                        self.saving = false
                    })
                }).catch(error => {
                    self.$message.error(error)
                    self.saving = false
                }).finally(() => {
                    self.saving = false
                })
            },
            upperCase (val) {
                this.patient.identity = val.toUpperCase()
            }
        }
    }
</script>

<template>
    <el-container>
        <el-header height="45px">
            <el-form :inline="true" class="demo-form-inline" size="small" :disabled="saving">
                <el-form-item>
                    <el-button @click="$router.go(-1)">取 消</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveAll()">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
                <div class="record-form-wrap p20">
                    <div class="form-content">
                        <h4>基本信息</h4>
                        <el-form ref="baseForm" label-position="right" label-width="100px" :rules="recordRules" :model="record" :disabled="saving">
                            <el-form-item label="科室" prop="oid" v-if="orgSelection.length > 0">
                                <el-cascader
                                        :options="orgSelection"
                                        :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'children'}"
                                        :disabled="singleOrg"
                                        clearable
                                        v-model="record.oidPath"
                                        style="width: 100%;">
                                </el-cascader>
                            </el-form-item>
                            <el-form-item label="类型" prop="hospitalized">
                                <el-radio-group v-model="record.hospitalized">
                                    <el-radio :label="parseInt(1)" border>住院</el-radio>
                                    <el-radio :label="parseInt(0)" border>门诊</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="病历号" prop="historySn">
                                <el-input v-model="record.historySn" placeholder="请输入患者病历号" @blur="handleHistorySnBlur" v-if="!!patient.id"></el-input>
                                <el-autocomplete
                                        v-else
                                        v-model="record.historySn"
                                        placeholder="请输入患者病历号"
                                        :fetch-suggestions="querySearchPatient"
                                        :trigger-on-focus="false"
                                        value-key="name"
                                        @select="handleSelectPatient"
                                        style="width: 100%;">
                                </el-autocomplete>
                            </el-form-item>
                            <el-form-item label="床位号" prop="bedid" v-if="record.hospitalized === 1">
                                <el-input v-model="record.bedid" placeholder="请输入住院床号"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="form-content">
                        <h4>患者信息
                            <small v-if="patient.id > 0" style="color: #E6A23C;">(如需修改患者信息，请保存病历后在病历详情中修改)
                                <el-button type="text" @click="clearPatient">清除</el-button>
                            </small>
                        </h4>
                        <el-form ref="patientForm" label-position="right" label-width="100px" :rules="patientRules" :model="patient" :disabled="patient.id > 0 || saving">
                            <el-form-item label="姓名" prop="name">
                                <el-input v-model="patient.name" placeholder="请输入患者姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证" prop="identity">
                                <el-autocomplete
                                        v-model="patient.identity"
                                        placeholder="请输入患者身份证号码"
                                        @change="upperCase"
                                        :fetch-suggestions="querySearchPatientByIdentity"
                                        :trigger-on-focus="false"
                                        value-key="name"
                                        @select="handleSelectPatient"
                                        style="width: 100%;">
                                </el-autocomplete>
                            </el-form-item>
                            <el-form-item label="性别" prop="sex">
                                <el-radio-group v-model="patient.sex">
                                    <el-radio :label="parseInt(1)" border>男</el-radio>
                                    <el-radio :label="parseInt(2)" border>女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="年龄" prop="age" v-if="!patient.identity">
                                <el-input type="age" v-model.number="patient.age" placeholder="请输入患者年龄"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号" prop="mobile">
                                <el-input type="mobile" v-model.number="patient.mobile" placeholder="请输入患者手机号"></el-input>
                            </el-form-item>
                            <el-form-item label="住址">
                                <el-cascader
                                        :options="positionSelection"
                                        :props="{checkStrictly: true, value: 'sn', label: 'name', children: 'children' }"
                                        clearable
                                        v-model="patient.positions"
                                        style="width: 100%;">
                                </el-cascader>
                            </el-form-item>
                            <el-form-item label="详细地址" prop="house">
                                <el-input v-model="patient.house" placeholder="请输入患者详细地址：xx幢xx单元xx室"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="form-content">
                        <h4>病历信息</h4>
                        <el-form ref="recordForm" label-position="right" label-width="100px" :model="record" :disabled="saving">
                            <el-form-item label="主治医生" prop="attending">
                                <el-select v-model="record.attending" placeholder="请选择医生" style="width: 100%;">
                                    <el-option
                                            v-for="item in doctorSelection"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.uid">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="诊断" prop="diagnoses">
                                <el-select
                                        v-model="diagnoses"
                                        multiple
                                        filterable
                                        remote
                                        allow-create
                                        default-first-option
                                        placeholder="输入关键词查找诊断(支持新建)"
                                        :remote-method="listDiagnosis"
                                        :loading="diagnoseLoading"
                                        @focus="listDiagnosis"
                                        style="width: 100%;">
                                    <el-option
                                            v-for="item in diagnoseSelection"
                                            :key="item.name"
                                            :label="item.name"
                                            :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="病情描述" prop="stateOfAnIllness">
                                <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="record.stateOfAnIllness" placeholder="请输入病情描述"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </el-scrollbar>
        </el-main>
    </el-container>
</template>

<style scoped>
    .record-form-wrap {
        background: #F2F6FC;
    }
    .form-content {
        padding: 20px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        width: 1050px;
        background: #FFF;
        margin: 10px auto;
    }
</style>
